import './CoverageModal.css'

import React, { useState } from 'react'
import Flag from 'react-world-flags'
import localhostSettings from '../../local' // adjust the path if needed
import { useTranslation } from 'react-i18next'
import NoCountries from '../../assets/NoCountries.svg'
import Close from '../../assets/Close.svg'
import FilterCountries from '../../FilterCountries'

interface CoverageModalProps {
  isOpen: boolean
  onClose: () => void
  supportedCountries: any[]
}

const CoverageModal: React.FC<CoverageModalProps> = ({ isOpen, onClose, supportedCountries }) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [filteredCountries, setFilteredCountries] = useState<any[]>([])
  const isRTL = localhostSettings.isRTL()
  const { t } = useTranslation()
  // const countries = supportedCountries.map((country: any) => ({
  //   id: country.id, // 3-digit ISO code (e.g., "USA")
  //   name: isRTL ? country.countryArabic : country.countryEnglish,
  //   operators: country.operators
  //     ?.map((op: any) => (isRTL ? op.operatorArabic : op.operatorEnglish))
  //     .join(', '),
  // }))


  if (!isOpen) return null
  return (
    <div className="c-modal-overlay" onClick={onClose}>
      <div className={`coverage-modal ${isRTL ? 'rtl' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className='bundel_coverage'>
          <div className='close-button'>
            <button onClick={onClose} className="c-close-btn">
              <img src={Close} alt='close' />
            </button>
          </div>
          <div className="c-modal-header">
            <div className='coverage-subtitle-text'>{t('Bundle_coverage')}</div>
            <p className="c-modal-subtitle">
              {t("You_can_enjoy_this_bundle_in_all_these_countries")}
            </p>
          </div>

          <div className="modal-info-box">
            {isRTL ? (
              <>
                للدول والمشغلين غير المدرجين في هذه القائمة، سيتم احتساب التكلفة حسب الاستخدام وفقاً
                لـ <a target="_blank" href="/wps/portal/web/personal/services/details/roaming-and-international/roaming-abroad/roaming-prices">أسعار التجوال حسب الاستخدام</a>. لتجنب هذه التكلفة، يمكنك تعطيل رسوم
                الاستخدام من التطبيق.
              </>
            ) : (
              <>
                For countries and operators not covered in this list, you'll be charged by usage, as
                per the <a target="_blank" href="/wps/portal/web/personal/services/details/roaming-and-international/roaming-abroad/roaming-prices">PAYG Roaming Rates</a>. To avoid paying these, you can disable
                PAYG charges from the app.
              </>
            )}
          </div>
          <div className="country-search-wrapper">
            <FilterCountries
              data={supportedCountries}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              onFilter={setFilteredCountries}
            />

            <ul className="country-s-list">
              {filteredCountries.length === 0 ? (
                <div className='no-country-option'>
                  <div className='country-summary'>
                    <div className='country-left'>
                      <img
                        src={NoCountries}
                        alt="NoCountries"
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: '50%',
                          objectFit: 'cover',
                        }}
                      />
                      <span className='no-country-name'>
                        {t("No_countries_found")}
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                filteredCountries.map((country, id) => (

                  <div key={id} className="country-s-option">
                    <div className="country-left">
                      <Flag
                        code={country.id}
                        style={{
                          width: 24,
                          height: 24,
                          borderRadius: '50%',
                          objectFit: 'cover',
                          marginRight: isRTL ? 0 : 6,
                          marginLeft: isRTL ? 6 : 0,
                        }}
                      />
                      <div>
                        <p className="country-name">{isRTL ? country.countryArabic : country.countryEnglish}</p>
                        <p className="country-ops">
                          {t("With")}{" "}
                          {Array.isArray(country.operators)
                            ? country.operators
                              .map((op: { operatorArabic: any; operatorEnglish: any }) => isRTL ? op.operatorArabic : op.operatorEnglish)
                              .join(', ')
                            : country.operators
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CoverageModal
